import { FormControl, FormLabel } from "@mui/material";
import { useState } from "react";

import { useFieldContext } from "components/Forms/AppForm";
import HTMLEditor from "components/UI/HTMLEditor";

import ErrorMessage from "../../helpers/ErrorMessage";

interface HtmlEditorProps {
  label: string;
  setEnforceFocusModal?: (_value: boolean) => void;
}

const HtmlEditor = ({ label, setEnforceFocusModal }: HtmlEditorProps) => {
  const field = useFieldContext<string>();
  const [_enforceFocusDefault, setEnforceFocusDefault] = useState(true);

  const isValid = field.state.meta.errors.length === 0;

  return (
    <FormControl>
      <FormLabel id={`${label}-html-editor-label`} color="primary">
        {label}
      </FormLabel>
      <HTMLEditor
        name={field.name}
        handleChange={(e: { target: { value: string } }) =>
          field.handleChange(e.target.value)
        }
        setIsValid={() => {}} // Once we refactor all forms to use the new form schema, we can remove this
        isValid={isValid}
        defaultValue={field.state.value}
        setEnforceFocusModal={setEnforceFocusModal || setEnforceFocusDefault}
        disabled={false}
      />
      <ErrorMessage />
    </FormControl>
  );
};
export default HtmlEditor;
